import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { fetchUserType } from '@/api/bff/user';
import { UserType } from '@/types/user';
import { Logger } from '@/services/logger';

export const useUserStore = defineStore('user', () => {
  const loggedInUserType = ref<UserType | null>(null);

  function resetUserStore() {
    loggedInUserType.value = null;
  }

  async function checkUser() {
    try {
      const result = await fetchUserType();

      if (result) {
        loggedInUserType.value = result.userType;
      }
    } catch (err) {
      Logger.logError('Fetching user type failed');
    }
  }

  async function getIsUserLoggedIn() {
    await checkUser();
    return isUserLoggedIn.value;
  }

  const isUserLoggedIn = computed(
    () => loggedInUserType.value && loggedInUserType.value !== UserType.SessionUser,
  );

  return {
    resetUserStore,
    isUserLoggedIn,
    loggedInUserType,
    checkUser,
    getIsUserLoggedIn,
  };
});
